<template>
  <div class="page-container commodity-container" @click="handleClick">
    <div class="anchor-block-container">
      <div class="anchor-block">
        <div
          v-for="(item, index) in anchorItemList"
          :key="index"
          class="anchor-item"
          :class="activeIndex === index ? 'anchor-item-ative' : ''"
          @click="handleToBlock(item, index)"
        >
          <span>{{ item.name }}</span>
          <Icon
            v-if="item.icon"
            size="16"
            class="right-icon"
            :type="item.icon"
            :color="item.iconColor"
          ></Icon>
          <!-- <span>{{ item.hasFilled }} / {{ item.requireKeyslength }}</span> -->
        </div>
      </div>
    </div>
    <div class="class-form-divide class-form-course-center">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { findComponentsDownward } from '@/utils/utils.js';
export default {
  name: 'AnchorContainer',
  provide() {
    return { AnchorInstance: this };
  },
  props: {
    anchorBlockTop: {
      type: Number,
      default: 125
    }
  },
  data() {
    return {
      activeIndex: 0,
      anchorItemList: []
    };
  },
  watch: {
    activeIndex(index) {
      // console.log(index, '============42482989----------');
    }
  },
  mounted() {
    this.$nextTick(() => {
      document
        .querySelector('.ivu-layout .ivu-layout .ivu-layout-content')
        .addEventListener('scroll', this.scrollActive, true);
    });
  },
  beforeDestroy() {
    document
      .querySelector('.ivu-layout .ivu-layout .ivu-layout-content')
      .removeEventListener('scroll', this.scrollActive, true);
  },
  methods: {
    handleClick() {
      this.$emit('handleClick');
    },
    getAnchor() {
      // return this.$children.filter(item => item.$options.name === 'TabPane');
      const AllAnchorItem = findComponentsDownward(this, 'AnchorItem');
      const Anchors = [];

      AllAnchorItem.forEach((item) => {
        Anchors.push(item);
      });

      // // 在 TabPane 使用 v-if 时，并不会按照预先的顺序渲染，这时可设置 index，并从小到大排序
      // TabPanes.sort((a, b) => {
      //   if (a.index && b.index) {
      //     return a.index > b.index ? 1 : -1;
      //   }
      // });
      return Anchors;
    },
    updateAnchor() {
      // console.log('this.getAnchor()', this.getAnchor())
      this.anchorItemList = this.getAnchor();
    },
    getBoxTrueOffsetTop(id) {
      const tabsHeight = document.getElementById('tabs').offsetHeight;
      const breadcrumbHeight =
        document.getElementsByClassName('breadcrumb-page')[0].offsetHeight;
      const trueOffsetTop =
        document.getElementById(id).offsetTop - tabsHeight - breadcrumbHeight;
      return trueOffsetTop;
    },
    handleToBlock(item, index) {
      console.log(item.id);
      this.activeIndex = index;
      // document.getElementById(item.id).scrollIntoView({ behavior: 'smooth', inline: 'start' });
      if (index === 0) {
        document.querySelector(
          '.ivu-layout .ivu-layout .ivu-layout-content'
        ).scrollTop = 0;
      } else {
        document.querySelector(
          '.ivu-layout .ivu-layout .ivu-layout-content'
        ).scrollTop = this.getBoxTrueOffsetTop(item.id);
      }
    },
    scrollActive() {
      const scrollTop = document.querySelector(
        '.ivu-layout .ivu-layout .ivu-layout-content'
      ).scrollTop;
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.querySelector(
        '.ivu-layout .ivu-layout .ivu-layout-content'
      ).scrollHeight;
      if (scrollTop + windowHeight === scrollHeight) {
        this.activeIndex = this.anchorItemList.length - 1;
        return;
      }
      // console.log('滚动条动了------');
      for (let i = 0; i <= this.anchorItemList.length - 1; i++) {
        const topItemScrollTop = this.getBoxTrueOffsetTop(
          this.anchorItemList[i].id
        );
        if (i === 0 && topItemScrollTop >= scrollTop) {
          this.activeIndex = 0;
          // console.log('第一个');
          break;
        }
        if (
          i === this.anchorItemList.length - 1 &&
          topItemScrollTop <= scrollTop
        ) {
          this.activeIndex = i;
          // console.log('最后一个');
          break;
        }
        if (i > 0 && i < this.anchorItemList.length - 1) {
          const nextItemScrollTop = this.getBoxTrueOffsetTop(
            this.anchorItemList[i + 1].id
          );
          // console.log(i, nextItemScrollTop, scrollTop, topItemScrollTop);
          if (topItemScrollTop >= scrollTop && scrollTop < nextItemScrollTop) {
            this.activeIndex = i;
            // console.log('中间的----', this.activeIndex);
            break;
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.commodity-container {
  display: flex;
  .class-form-divide {
    flex: 1;
  }
}
.anchor-block-container {
  // display: inline-block;
  width: 240px;
  margin-right: 16px;
  height: 10px;
  z-index: 1;
  flex: 0 0 240px;
}
.anchor-block {
  background: #fff;
  width: 200px;
  box-sizing: border-box;
  padding: 8px 16px;
  position: fixed;
  left: 210px;
  // top: 125px;
  border: 1px solid #ccc;
  z-index: 1000;
  .anchor-item {
    padding: 8px 0;
    cursor: pointer;
  }
  .anchor-item-ative {
    color: #488ffa;
  }
  .right-icon {
    margin-left: 8px;
  }
}
</style>
